import { render } from "./BrandTc.vue?vue&type=template&id=bf9e6fd4"
import script from "./BrandTc.vue?vue&type=script&lang=js"
export * from "./BrandTc.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__